//App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Navbar, Nav, Dropdown } from 'react-bootstrap';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider, useAuth } from './context/AuthContext'; // 確認 `useAuth` 已正確導入
import { isSuperAdmin } from './utils/superAdmin';
import { terminologyConfig, useTerminologyDomRewriter } from './utils/terminology';
// import { hasPermission } from './utils/permissions'; // 不再使用
// import ProtectedRoute from './utils/ProtectedRoute'; // 改為直接控制
import Home from './Home';
import LoginPage from './LoginPage';
import RoleSelection from './RoleSelection';
import IMCMap from './IMC-map';
import TopicsTable from './topicsTable';
import InnovationAwards from './InnovationAwards'; // 歷屆創新獎項
import LecturerTable from './LecturerTable';
import CompanyTable from './CompanyTable';
import CompanyMap from './CompanyMap';
import CompanyCoordinateRepair from './CompanyCoordinateRepair';
import EmployeeTable from './Employee';
import EmpLineinfo from './EmpLineinfo';
import ExperienceTable from './ExperienceTable';
import ParticipationTable from './ParticipationsTable';
import ActivitiesTable from './ActivitiesTable';
import VisitsTable from './VisitsTable'; // 導入 VisitsTable 組件
import NewPage from './NewPage';
import Aiot from './Aiot';
import SmartCoordinateRepair from './SmartCoordinateRepair';
import Personal from './components/Personal';
import SqltableorderTable from './SqltableorderTable';
import AllEmployeeTable from './AllEmployee';
import EmployeeBatch from './EmployeeBatch';
import PermissionManager from './utils/PermissionManager'; // 確保路徑正確
import LinePhotoWall from './PhotoWall';
import Personal1 from './components/Personal1';
import EDMWall from './EDMWall';
import JoinPage from './JoinPage';
import Pjoinpage from './Pjoinpage';
import UnauthorizedPage from './utils/UnauthorizedPage'; // 引入獨立的UnauthorizedPage檔案
import EDMPhotoWall from './EDMPhotoWall';
import CheckIn from './CheckIn'; // 新增手機簽到組件
import FaceCheckIn from './FaceCheckIn'; // 新增人臉簽到組件
import CameraTest from './CameraTest'; // 相機測試組件
import MemberAnalytics from './MemberAnalytics'; // 新增社友分析圖表組件
import MagazineIntegration from './MagazineIntegration'; // 新增全國社刊整合組件
import SystemLogs from './SystemLogs'; // 新增系統日誌組件
import MemberDirectory from './MemberDirectory'; // 新增社友名錄組件
import ActivityParticipationAnalysis from './ActivityParticipationAnalysis'; // 新增活動參與分析組件
import MemberParticipationAnalysis from './MemberParticipationAnalysis'; // 新增社友參與狀況分析組件
import AllMemberManagement from './AllMemberManagement'; // 新增全國社友資訊管理組件
import SecretaryDataChanges from './SecretaryDataChanges'; // 新增社友資料異動查詢組件
import PartnerActivities from './PartnerActivities'; // 新增友社活動查詢組件
import PermissionMonitor from './PermissionMonitor'; // 新增權限監控組件
import PublicEDM from './components/PublicEDM'; // 新增公開 EDM 頁面組件
import SubjectManagement from './SubjectManagement'; // 新增財務管理 - 科目管理組件
import BudgetProgress from './BudgetProgress'; // 新增財務管理 - 預算檢視表組件
import BudgetManagement from './BudgetManagement'; // 新增財務管理 - 預算表管理組件
import ReimburseManagement from './ReimburseManagement'; // 新增財務管理 - 請款單管理組件
import IncomeManagement from './IncomeManagement'; // 新增財務管理 - 收入管理組件
import TransactionManagement from './TransactionManagement'; // 新增財務管理 - 交易流水帳組件
import TermManagement from './TermManagement'; // 新增財務管理 - 屆別管理組件
import LineMessageManagement from './LineMessageManagement'; // 新增 LINE 訊息管理組件
import ActivityNotifications from './ActivityNotifications'; // 新增活動通知管理組件

//import './App.css';  // 確保這一行在 App.js 中


  


const NavigationBar = () => {
  const { isAuthenticated, user, handleLogout } = useAuth(); // 正確使用 useAuth
  const canViewSecretaryMenu = isSuperAdmin(user?.e_id) || user?.e_position === 17;
  
  // 權限控制邏輯
  const isAdmin = isSuperAdmin(user?.e_id) || user?.e_position === 17; // 管理者、秘書
  const isMember = user?.e_group === 5; // 社友
  const isHigherGroup = user?.e_group > 5; // e_group > 5 的用戶
  
  // 基本權限：管理者、秘書、社友可以存取的功能
  const hasBasicAccess = isAdmin || isMember;
  
  // 報名權限：所有已登入用戶都可以報名活動
  const hasRegistrationAccess = isAuthenticated;
  // 簡化權限檢查 - 直接同步控制
  const renderDropdownMenu = (shouldShow, menuTitle, items) => {
    
    return shouldShow && (
      <Dropdown>
        <Dropdown.Toggle
          as={Nav.Link}
          variant="link"
          id={`${menuTitle}-dropdown`}
          style={{ color: 'white', textDecoration: 'none',fontSize: '20px', textAlign: 'center' }}
        >
          {menuTitle}
        </Dropdown.Toggle>
        <Dropdown.Menu style={{ backgroundColor: '#141414' }}>
          {items.map(item => (
            item.show !== false && (
              <Dropdown.Item
                as={Link}
                to={item.link}
                key={item.label}
                style={{
                  color: 'white',
                  textDecoration: 'none',
                  backgroundColor: '##070807',
                  fontSize: '20px', 
                  textAlign: 'center'
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = '#0a0a0a'} // 滑鼠懸停時背景變深灰色
                onMouseOut={(e) => e.target.style.backgroundColor = '#555555'}  // 滑鼠移出時背景恢復灰色
              >
                {item.label}
              </Dropdown.Item>
            )
          ))}
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  return (
    <Navbar bg="dark" variant="dark" expand="lg" className="w-100">
  <Navbar.Brand as={Link} to="/" style={{ color: 'white', textDecoration: 'none',fontSize: '20px', textAlign: 'center'  }}>
    &nbsp;&nbsp;{terminologyConfig.menuVersionLabel}
  </Navbar.Brand>
  <Navbar.Toggle aria-controls="basic-navbar-nav" />
  <Navbar.Collapse id="basic-navbar-nav">
    <Nav className="me-auto">
      {isAuthenticated && (
        <>
          {/* 工商學習 - 管理者、秘書、社友可見 */}
          {renderDropdownMenu(
            hasBasicAccess, // 管理者、秘書、社友可看到
            '找講題及參訪公司',
            [
              { label: '找最近被參訪公司記錄', link: '/VisitsTable' },
              { label: '找最近演講題目', link: '/TopicsTable' },
              { label: '歷屆創新獎項', link: '/InnovationAwards' },
              { label: '找參訪公司', link: '/CompanyTable' },
              { label: '找講師', link: '/LecturerTable' }
            ]
          )}

                   
          {/* 友社交流 - 管理者、秘書、社友可見 */}
          {renderDropdownMenu(
            hasBasicAccess, // 管理者、秘書、社友可看到
            '認識社友',
            [
              { label: '社友服務及產品海報', link: '/EDMPhotoWall' },
              { label: '社友服務輪播', link: `/EDMWall` }, 
              { label: '社友相片錄', link: '/LinePhotoWall' },
              { label: '社友名錄', link: '/MemberDirectory' },
              { label: '社友公司服務資訊', link: '/AllEmployeeTable' },
              { label: '社友社職經歷', link: '/ExperienceTable?self=false' },
              { label: '社友參與活動記錄', link: '/ParticipationsTable?self=false' },
              { label: '友社活動查詢', link: '/PartnerActivities' },
              { label: '全國社友分佈地圖', link: '/IMC-map' }
              
            ]
          )}

                 
          {/* 報表資訊 - 管理者、秘書、社友可見 */}
          {renderDropdownMenu(
            hasBasicAccess, // 管理者、秘書、社友可看到
            '報表資訊',
            [
              { label: '各社社友分析圖表', link: '/MemberAnalytics' },
              { label: '各社社友參與活動分析', link: '/ActivityParticipationAnalysis' },
              { label: '社友參與狀況分析', link: '/MemberParticipationAnalysis' },
              { label: '全國社刊整合', link: '/MagazineIntegration' }
            ]
          )}

          {/* 系統管理 - e_id=80 或 e_group=1 可以看到 */}
          {renderDropdownMenu(
            isSuperAdmin(user?.e_id) || user?.e_group === 1, // 管理員或系統管理群組可看到
            '系統管理',
            [
              { label: '系統日誌查詢', link: '/SystemLogs' },
              { label: 'API 調用監控', link: '/PermissionMonitor' },
              { label: '所有社友資訊', link: '/AllMemberManagement' },
              { label: '智能座標修復', link: '/SmartCoordinateRepair' },
              { label: '座標修復系統', link: '/CompanyCoordinateRepair' }
            ]
          )}

          {/* 高權限組用戶專區 - 只有 e_group > 5 的用戶看到 */}
          {renderDropdownMenu(
            isHigherGroup, // 只有 e_group > 5 的用戶可看到
            '個人專區',
            [
              { label: '活動報名', link: '/Pjoinpage' }, // 所有用戶都可以報名
              { label: '個人資料修改', link: `/personal/${user?.e_id}` } // 所有用戶都可以修改個人資料
            ]
          )}

          {/* 一般社友專區 - 管理者、秘書、社友可見 */}
          {renderDropdownMenu(
            hasBasicAccess, // 管理者、秘書、社友可看到
            '報名及個人資訊專區',
            [
              { label: '活動報名', link: '/Pjoinpage' }, // 所有用戶都可以報名
              { label: '個人資料修改', link: `/personal/${user?.e_id}` }, // 所有用戶都可以修改個人資料
              { label: '社友名錄', link: '/MemberDirectory' }, // 管理者、秘書、社友可見
              { label: '社內社友', link: '/Employee' }, // 管理者、秘書、社友可見
              { label: '參與記錄', link: '/ParticipationsTable?self=true' }, // 管理者、秘書、社友可見
              { label: '個人經歷', link: '/ExperienceTable?self=true' }, // 管理者、秘書、社友可見
              { label: '社內活動', link: '/ActivitiesTable?self=true' } // 管理者、秘書、社友可見
            ]
          )}

          {/* 秘書專用 */}
          {canViewSecretaryMenu && (
            <Dropdown>
              <Dropdown.Toggle
                as={Nav.Link}
                variant="link"
                id="secretary-dropdown"
                style={{ color: 'white', textDecoration: 'none',fontSize: '20px', textAlign: 'center' }}
              >
                秘書使用
              </Dropdown.Toggle>
              <Dropdown.Menu style={{ backgroundColor: '#141414' }}>
                <Dropdown.Item
                  as={Link}
                  to="/EmployeeBatch"
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                    backgroundColor: '##070807',
                    fontSize: '20px',
                    textAlign: 'center'
                  }}
                  onMouseOver={(e) => e.target.style.backgroundColor = '#0a0a0a'}
                  onMouseOut={(e) => e.target.style.backgroundColor = '#555555'}
                >
                  社友修改
                </Dropdown.Item>
                <Dropdown.Item
                  as={Link}
                  to="/ActivitiesTable?self=true"
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                    backgroundColor: '##070807',
                    fontSize: '20px',
                    textAlign: 'center'
                  }}
                  onMouseOver={(e) => e.target.style.backgroundColor = '#0a0a0a'}
                  onMouseOut={(e) => e.target.style.backgroundColor = '#555555'}
                >
                  活動新增
                </Dropdown.Item>
                <Dropdown.Item
                  as={Link}
                  to="/CompanyTable"
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                    backgroundColor: '##070807',
                    fontSize: '20px',
                    textAlign: 'center'
                  }}
                  onMouseOver={(e) => e.target.style.backgroundColor = '#0a0a0a'}
                  onMouseOut={(e) => e.target.style.backgroundColor = '#555555'}
                >
                  工商參訪新增
                </Dropdown.Item>
                <Dropdown.Item
                  as={Link}
                  to="/LecturerTable"
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                    backgroundColor: '##070807',
                    fontSize: '20px',
                    textAlign: 'center'
                  }}
                  onMouseOver={(e) => e.target.style.backgroundColor = '#0a0a0a'}
                  onMouseOut={(e) => e.target.style.backgroundColor = '#555555'}
                >
                  講師新增
                </Dropdown.Item>
                <Dropdown.Item
                  as={Link}
                  to="/SecretaryDataChanges"
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                    backgroundColor: '##070807',
                    fontSize: '20px',
                    textAlign: 'center'
                  }}
                  onMouseOver={(e) => e.target.style.backgroundColor = '#0a0a0a'}
                  onMouseOut={(e) => e.target.style.backgroundColor = '#555555'}
                >
                  社友資料異動查詢
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}

          {/* 財務管理 - 秘書和管理員可見 */}
          {renderDropdownMenu(
            canViewSecretaryMenu, // 秘書、管理員可看到
            '財務管理',
            [
              { label: '屆別管理', link: '/TermManagement' },
              { label: '科目管理', link: '/SubjectManagement' },
              { label: '預算表管理', link: '/BudgetManagement' },
              { label: '預算檢視表', link: '/BudgetProgress' },
              { label: '收入管理', link: '/IncomeManagement' },
              { label: '請款單管理', link: '/ReimburseManagement' },
              { label: '交易流水帳', link: '/TransactionManagement' }
            ]
          )}

          {/* 訊息管理 - 秘書和管理員可見 */}
          {renderDropdownMenu(
            canViewSecretaryMenu, // 秘書、管理員可看到
            '訊息管理',
            [
              { label: 'LINE 訊息推播', link: '/LineMessageManagement' },
              { label: '活動通知管理', link: '/ActivityNotifications' }
            ]
          )}

          {/* 設定專區 - 🔒 只有 e_id=80 (超級管理員) 可以看到 */}
          {renderDropdownMenu(
            isSuperAdmin(user?.e_id), // 只有超級管理員可看到設定專區
            '設定專區',
            [
              { label: '社友資訊', link: '/EmpLineinfo' },
              { label: '設定', link: '/SqltableorderTable' }              
            ]
          )}
          
          {/* 設定與登出 */}
          
          <Nav.Link as={Link} to="/" onClick={handleLogout} style={{ color: 'white', textDecoration: 'none',fontSize: '20px', textAlign: 'center'  }}>
            登出
          </Nav.Link>
        </>
      )}

      {/* 登入狀態顯示 */}
      <Nav.Link as={Link} to="/" style={{ color: 'white', textDecoration: 'none',fontSize: '20px', textAlign: 'center'  }}>
        活動訊息
      </Nav.Link>
      <li className="nav-item">
        <Link className="nav-link fw-bold" to="/login" style={{ color: 'white', textDecoration: 'none',fontSize: '20px', textAlign: 'center' }}>
          {isAuthenticated ? `切換帳號（當前：${user?.e_name} )` : '登入'}
        </Link>
      </li>
    </Nav>
  </Navbar.Collapse>
</Navbar>

  

  );
};

function App() {
  useTerminologyDomRewriter();

  return (
    <HelmetProvider>
      <Router>
        <AuthProvider>
          <div>
            <NavigationBar />
            <div style={{ width: '100vw', padding: '0', margin: '0' }}>
              <Routes>
              {/* 非受保護的路由 */}
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/role-selection" element={<RoleSelection />} />
              <Route path="/new-page" element={<NewPage />} />
              <Route path="/Aiot" element={<Aiot />} />

              {/* 受保護的路由，基於權限的訪問控制 */}
              <Route path="/IMC-map" element={<IMCMap />} />
              <Route path="/TopicsTable" element={<TopicsTable />} />
              <Route path="/InnovationAwards" element={<InnovationAwards />} />
              <Route path="/CompanyMap" element={<CompanyMap />} />
              <Route path="/CompanyCoordinateRepair" element={<CompanyCoordinateRepair />} />
              <Route path="/LecturerTable" element={<LecturerTable />} />
              <Route path="/CompanyTable" element={<CompanyTable />} />
              <Route path="/Employee" element={<EmployeeTable />} />
              <Route path="/ExperienceTable" element={<ExperienceTable />} />
              <Route path="/ParticipationsTable" element={<ParticipationTable />} />
              <Route path="/ActivitiesTable" element={<ActivitiesTable />} />
              <Route path="/PartnerActivities" element={<PartnerActivities />} />
              <Route path="/Personal" element={<Personal />} /> {/* 新增對應路由 */}
              <Route path="/Personal/:id" element={<Personal />} /> {/* 保留原有的路由 */}
              <Route path="/SqltableorderTable" element={<SqltableorderTable />} />
              <Route path="/AllEmployeeTable" element={<AllEmployeeTable />} />
              <Route path="/EmployeeBatch" element={<EmployeeBatch />} />
              <Route path="/PermissionManager" element={<PermissionManager />} />
              <Route path="/VisitsTable" element={<VisitsTable />} /> {/* 新增訪問記錄的受保護路由 */}
              <Route path="/EmpLineinfo" element={<EmpLineinfo />} /> {/* 新增訪問記錄的受保護路由 */}
              <Route path="/LinePhotoWall" element={<LinePhotoWall />} /> 
              <Route path="/Personal1" element={<Personal1 />} /> {/* 新增對應路由 */}
              <Route path="/EDMWall" element={<EDMWall />} /> 
              <Route path="/JoinPage" element={<JoinPage />} /> 
              <Route path="/Pjoinpage" element={<Pjoinpage />} /> 
              <Route path="/EDMPhotoWall" element={<EDMPhotoWall />} />
              <Route path="/MemberDirectory" element={<MemberDirectory />} />
              <Route path="/MemberAnalytics" element={<MemberAnalytics />} />
              <Route path="/ActivityParticipationAnalysis" element={<ActivityParticipationAnalysis />} />
              <Route path="/MemberParticipationAnalysis" element={<MemberParticipationAnalysis />} />
              <Route path="/MagazineIntegration" element={<MagazineIntegration />} />
              <Route path="/SystemLogs" element={<SystemLogs />} />
              <Route path="/AllMemberManagement" element={<AllMemberManagement />} />
              <Route path="/SmartCoordinateRepair" element={<SmartCoordinateRepair />} />
              <Route path="/SecretaryDataChanges" element={<SecretaryDataChanges />} />
              <Route path="/PermissionMonitor" element={<PermissionMonitor />} />
              <Route path="/SubjectManagement" element={<SubjectManagement />} />
              <Route path="/BudgetManagement" element={<BudgetManagement />} />
              <Route path="/BudgetProgress" element={<BudgetProgress />} />
              <Route path="/IncomeManagement" element={<IncomeManagement />} />
              <Route path="/ReimburseManagement" element={<ReimburseManagement />} />
              <Route path="/TransactionManagement" element={<TransactionManagement />} />
              <Route path="/TermManagement" element={<TermManagement />} />
              <Route path="/LineMessageManagement" element={<LineMessageManagement />} />
              <Route path="/ActivityNotifications" element={<ActivityNotifications />} />

              {/* 簽到相關路由 (公開訪問) */}
              <Route path="/checkin/mobile" element={<CheckIn />} />
              <Route path="/checkin/face" element={<FaceCheckIn />} />
              <Route path="/camera-test" element={<CameraTest />} />
              
              {/* 公開 EDM 分享頁面 (不需登入) */}
              <Route path="/public/edm/:shareToken" element={<PublicEDM />} />
              
              {/* 權限不足或未登入的重定向路由 */}
              <Route path="/unauthorized" element={<UnauthorizedPage />} />
              </Routes>
            </div>
          </div>
        </AuthProvider>
      </Router>
    </HelmetProvider>
  );
}



export default App;
